import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';

const values = [
  {
    title: 'Pets first, always',
    body: 'Every decision is run against one question: is this better for the pet?',
  },
  {
    title: 'Small teams, big ownership',
    body: "We're 11–50 people. You won't be a cog — you'll shape what we build next.",
  },
  {
    title: 'Open a category, don\'t add a feature',
    body: 'We don\'t do me-too. If we\'re opening it, it\'s because there\'s a real gap.',
  },
  {
    title: 'In the room, on the floor',
    body: 'Our team spends time at Nest and Wag & Wine. The work and the customers stay close.',
  },
];

const Careers = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <section className="bg-white pt-40 pb-10 sm:pt-48 sm:pb-12">
      <div className="mx-auto grid max-w-6xl gap-12 px-4 sm:px-6 lg:grid-cols-[1.2fr_1fr] lg:items-end lg:px-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Careers</p>
          <h1 className="mt-3 text-4xl font-semibold leading-[1.05] tracking-tight text-neutral-900 sm:text-5xl">
            Make something pets actually want.
          </h1>
          <p className="mt-5 max-w-xl text-base text-neutral-600 sm:text-lg">
            We hire across pet care, hospitality, operations, design and engineering. No openings
            are public right now — but we'd still like to meet you.
          </p>
        </div>

        <div className="rounded-2xl border border-neutral-200 bg-neutral-50 p-6 sm:p-7">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500">
            Open roles
          </p>
          <p className="mt-2 text-lg font-semibold text-neutral-900">
            0 active openings
          </p>
          <p className="mt-1 text-sm text-neutral-600">
            We hire opportunistically. Tell us what you'd want to work on.
          </p>
          <a
            href="mailto:shekhar@petcart.com?subject=Introducing%20myself"
            className="mt-5 inline-flex items-center justify-between gap-3 rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:bg-primary/90"
          >
            Write to shekhar@petcart.com
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>

    <section className="bg-neutral-50 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-semibold tracking-tight text-neutral-900 sm:text-3xl">
          How we work
        </h2>
        <div className="mt-8 grid gap-px overflow-hidden rounded-2xl bg-neutral-200 sm:grid-cols-2">
          {values.map((v) => (
            <div key={v.title} className="bg-white p-6 sm:p-7">
              <p className="text-sm font-semibold text-neutral-900">{v.title}</p>
              <p className="mt-2 text-sm leading-6 text-neutral-600">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-sm uppercase tracking-wider text-neutral-500">Don't see a role?</p>
        <p className="mt-3 text-xl font-medium text-neutral-900 sm:text-2xl">
          Send a short note about what you'd like to work on — most of our hires start exactly that way.
        </p>
      </div>
    </section>

    <Footer />
  </div>
);

export default Careers;
